import { create } from 'zustand';

export const useUserStore = create(set => ({
  user: null,
  silentAttempted: false,
  setUser: nextUser => set({ user: nextUser }),
  setSilentAttempted: nexSilentAttempted => set({ silentAttempted: nexSilentAttempted }),
}));
